import { useAuthStore } from "@/stores/auth.store";
import i18n from "../i18n";
import axios from "axios";
import router from "@/router";

const API_HELPERS = {
  endpoints: {
    backendUrl: process.env.VUE_APP_API_URL || "https://prod.ewoodsapp.pl/api/",
    auth: {
      register: "auth/register",
      acceptOfTerms: "users/role",
      login: "auth/login",
      verifyAccount: "auth/verification",
      facebookLogin: "auth/login-facebook",
      googleLogin: "auth/login-google",
      forgotPassword: "auth/remind-password",
      resetPassword: "auth/reset-password",
      refreshToken: "auth/refresh-token",
      checkToken: "auth/check-token",
    },
    guest: {
      acceptProjectInvitation: "projects/accept-invitation",
    },
    currency: {
      currency: "currency",
    },
    user: {
      finances: {
        data: "wallets/users/{userId}",
        payout: "wallets/{walletId}/payouts-requests",
        accountNumber: {
          getCode: "wallets/{walletId}/account-numbers/change",
          change: "wallets/{walletId}/account-numbers",
        },
      },
      allSpecialization: "specializations",
      profile: "users/profile/",
      updateUser: "users/update",
      uploadProfileImage: "images",
      removeProfileImage: "users/profileImage",
      settings: {
        changePassword: "auth/change-password",
        changePrivacySettings: "users/privacy-settings",
        changeTwoStepVerificationSettings: "users/two-step-verification",
        deleteAccount: "users/delete",
      },
      clients: {
        clientsList: "clients",
        sortTypes: "clients/sort-types",
        deleteClient: "clients",
      },
      products: {
        sortTypes: "products/sort-types",
        allProducts: "products",
        productTypes: "products/types",
      },
      projects: {
        projectsList: "projects",
        sortTypes: "projects/sort-types",
        filterTypes: "projects/filters",
        deleteProject: "projects",
        addProject: "projects",
        editProject: "projects",
        info: "projects",
        inviteMembers: "projects/invite",
        sendAgainInvitation: "design-proposals/{projectId}/invitation",
        removeMembers: "projects/{projectId}/members",
        deleteProjectRoom: "projects/{projectId}/rooms/{roomId}",
        updateProjectRoomFurnitures:
          "projects/{projectId}/rooms/{roomId}/furnitures",
        addRoomsToProject: "projects/{projectId}/rooms",
        addManyRoomsToProject: "projects/{projectId}/many-rooms",
        addFurnituresToRoom: "projects/{projectId}/rooms/{roomId}/furnitures",
        addFurnituresToRoomWithAmount:
          "projects/{projectId}/rooms/{roomId}/furnitures-with-amount",
        addManyRoomsWithFurnituresAmount:
          "projects/{projectId}/rooms/furnitures-with-amount",
        addManyFurnituresToRooms: "projects/{projectId}/rooms/furnitures",
        updateRoomParameters: "projects/{projectId}/rooms/{roomId}/parameters",
        updateManyRoomsParameters: "projects/{projectId}/rooms/parameters",
        addImageToProject: "projects/{projectId}/images",
        deleteImageFromProject: "projects/{projectId}/images/{imageId}",
        settings: {
          rooms: "rooms",
          furnitures: "rooms/furnitures",
          furniutrueImage: "products/types/{furnitureId}/image",
        },
        details: {
          changeAmount:
            "design-proposals/{proposalId}/products/{productId}/amount",
          exchangeProduct: "design-proposals/{proposalId}/products/exchange",
          deleteProduct: "design-proposals/{proposalId}/products/{productId}",
          addProductToProposal: "design-proposals/{proposalId}/products",
          comments: {
            getComments: "design-proposals/{designProposalId}/comments",
            saveComment: "design-proposals/{designProposalId}/comments",
            saveSubcomment:
              "design-proposals/{designProposalId}/comments/{subCommentId}/subcomments",
            removeComment:
              "design-proposals/{designProposalId}/comments/{commentId}",
            removeSubcomment:
              "design-proposals/{designProposalId}/comments/{commentId}/subcomments/{subCommentId}",
            editComment:
              "design-proposals/{designProposalId}/comments/{commentId}",
            editSubcomment:
              "design-proposals/{designProposalId}/comments/{commentId}/subcomments/{subCommentId}",
          },
        },
        orders: {
          list: "projects/{projectId}/orders",
        },
      },
      styleQuiz: {
        photos: "style-quiz-images",
        styles: "styles",
        saveStyle: "projects/{projectId}/style-quiz-choose",
        submitPhotos: "projects/{projectId}/style-quiz-images",
      },
      shoppingList: {
        getShoppingList: "projects/{projectId}/shoppingLists",
        addProductToShoppingListRoom:
          "projects/{projectId}/shoppingLists/{shoppingListId}/rooms/{roomId}/products",
        addRoomToShoppingList:
          "projects/{projectId}/shoppingLists/{shoppingListId}/rooms",
        addImagesToShoppingListRoomProduct:
          "projects/{projectId}/shoppingLists/{shoppingListId}/rooms/{roomId}/products/{productId}",
        removeShoppingListProductImage:
          "projects/{projectId}/shoppingLists/{shoppingListId}/rooms/{roomId}/products/{productId}/images/{imageId}",
        removeProductFromShoppingList:
          "projects/{projectId}/shoppingLists/{shoppingListId}/rooms/{roomId}/products/{productId}",
        editOrderOfShoppingListProduct:
          "projects/{projectId}/shoppingLists/{shoppingListId}/rooms/{roomId}/products/order",
        editShoppingListProduct:
          "projects/{projectId}/shoppingLists/{shoppingListId}/rooms/{roomId}/products/{productId}",
        getProductComments:
          "projects/{projectId}/shoppingLists/{shoppingListId}/rooms/{roomId}/products/{productId}/comments",
        editShoppingListProductAcceptance:
          "projects/{projectId}/shoppingLists/{shoppingListId}/rooms/{roomId}/products/{productId}",
        moveShoppingListProductToAnotherRoom:
          "projects/{projectId}/shoppingLists/{shoppingListId}/rooms/{roomId}/products/{productId}",
        deleteShoppingListRoom:
          "projects/{projectId}/shoppingLists/{shoppingListId}/rooms/{roomId}",
        editShoppingListRoom:
          "projects/{projectId}/shoppingLists/{shoppingListId}/rooms/{roomId}",
        addFilesToShoppingListProduct:
          "projects/{projectId}/shoppingLists/{shoppingListId}/rooms/{roomId}/products/{productId}/files",
        removeFileToShoppingListProduct:
          "projects/{projectId}/shoppingLists/{shoppingListId}/rooms/{roomId}/products/{productId}/files/{fileId}",
        editShoppingList: "projects/{projectId}/shoppingLists/{shoppingListId}",
        clearShoppingList:
          "projects/{projectId}/shoppingLists/{shoppingListId}/clear",
        webscrape: "webscraping",
        addShoppingListToCart:
          "projects/{projectId}/shoppingLists/{shoppingListId}/addToCart",
        export: "projects/{projectId}/shoppingLists/{shoppingListId}/export",
        changeCategoryOrder: "projects/{projectId}/shoppingLists/{shoppingListId}/rooms/order"
      },
    },
    shoppingCart: {
      getAllBasket: "projects/{projectId}/shopping-carts",
      addProductsToBasket: "shopping-carts/products",
      changeAmountProductInBasket: "shopping-carts/{basketId}/products",
      removeProductFromBasket: "shopping-carts/{basketId}/products/{productId}",
      paymentForBasket: "shopping-carts/{basketId}/payment",
    },
    admin: {
      orders: {
        list: "admin/orders",
        update: "admin/orders",
      },
      allProducts: "admin/products",
      productSortTypes: "products/sort-types",
      productTypes: "products/types",
      products: {
        images: {
          addNewImages: "admin/products/{productId}/images",
          deleteImage: "admin/products/{productId}/images/{imageId}",
        },
      },
      users: {
        ewoods: "admin/users",
        ewoodsUpdateUser: "admin/users",
        ewoodsDeleteUser: "admin/users/{userId}",
        ewoodsBlockUser: "admin/users/{userId}/block",
        ewoodsUnblockUser: "admin/users/{userId}/unblock",
      },
      styleQuiz: {
        styles: "styles",
        addStyleDesc: "styles/descriptions",
        updateStyleImage: "styles/{styleId}/image",
        updateStyleDesc: "styles/descriptions/{styleDescId}",
        deleteStyleDesc: "styles/descriptions/{styleDescId}",
      },
      styleQuizSteps: {
        images: "style-quiz-images",
      },
      producers: {
        allProducers: "vendors",
        regions: "app/regions",
        filesTypes: "files/available-import-types",
        files: "files",
        addProducer: "vendors",
        updateProducer: "vendors",
        deleteProducer: "vendors",
      },
      requestsForPayments: {
        all: "admin/payouts-requests",
        changeStatus: "wallets/{walletId}/payouts-requests/{requestId}",
      },
    },
  },
};

const API_CODES = [
  "000",
  "001",
  "002",
  "003",
  "004",
  "005",
  "006",
  "007",
  "008",
  "009",
  "010",
  "011",
  "012",
  "013",
  "014",
  "018",
  "022",
  "023",
  "024",
  "025",
  "026",
  "027",
  "028",
  "400",
  "401",
  "403",
  "404",
];

export default class ApiHelper {
  static loginUrl() {
    return API_HELPERS.endpoints.backendUrl + API_HELPERS.endpoints.auth.login;
  }

  static loginGoogle() {
    return (
      API_HELPERS.endpoints.backendUrl + API_HELPERS.endpoints.auth.googleLogin
    );
  }

  static loginFacebook() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.auth.facebookLogin
    );
  }

  static registerUrl() {
    return (
      API_HELPERS.endpoints.backendUrl + API_HELPERS.endpoints.auth.register
    );
  }

  static acceptOfTermsUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.auth.acceptOfTerms
    );
  }

  static forgotPasswordUrl(email) {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.auth.forgotPassword +
      `?email=${email}`
    );
  }

  static getCheckTokenUrl() {
    return (
      API_HELPERS.endpoints.backendUrl + API_HELPERS.endpoints.auth.checkToken
    );
  }

  static resetPasswordUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.auth.resetPassword
    );
  }

  static verifyAccountUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.auth.verifyAccount
    );
  }

  static getRefreshTokenUrl() {
    return (
      API_HELPERS.endpoints.backendUrl + API_HELPERS.endpoints.auth.refreshToken
    );
  }

  static getProfileUrl() {
    const authStore = useAuthStore();
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.profile +
      authStore?.user?.id
    );
  }

  static getChangePasswordUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.settings.changePassword
    );
  }

  static getChangePrivacySettingsUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.settings.changePrivacySettings
    );
  }

  static getDeleteAccountUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.settings.deleteAccount
    );
  }

  static getAllSpecializationUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.allSpecialization
    );
  }

  static getAcceptProjectInvitationUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.guest.acceptProjectInvitation
    );
  }

  static getUpdateUserUrl() {
    return (
      API_HELPERS.endpoints.backendUrl + API_HELPERS.endpoints.user.updateUser
    );
  }

  static getClientsUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.clients.clientsList
    );
  }

  static getClientsSortTypesUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.clients.sortTypes
    );
  }

  static getDeleteClientUrl(id) {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.clients.deleteClient +
      "/" +
      id
    );
  }

  static getProjectsUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.projects.projectsList
    );
  }

  static getProjectsSortTypesUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.projects.sortTypes
    );
  }

  static getProjectsFilterTypesUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.projects.filterTypes
    );
  }

  static addRoomsToProjectUrl(id) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.projects.addRoomsToProject;
    url = url.replace("{projectId}", id);
    return url;
  }

  static addManyRoomsToProjectUrl(id) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.projects.addManyRoomsToProject;
    url = url.replace("{projectId}", id);
    return url;
  }

  static addFurnituresToRoomUrl(projectId, roomId) {
    let url = API_HELPERS.endpoints.user.projects.addFurnituresToRoom;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{roomId}", roomId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static addFurnituresToRoomWithAmountUrl(projectId, roomId) {
    let url = API_HELPERS.endpoints.user.projects.addFurnituresToRoomWithAmount;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{roomId}", roomId);
    return API_HELPERS.endpoints.backendUrl + url;
  }
  static addManyRoomsWithFurnituresAmountUrl(projectId) {
    let url =
      API_HELPERS.endpoints.user.projects.addManyRoomsWithFurnituresAmount;
    url = url.replace("{projectId}", projectId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static addManyFurnituresToManyRoomsUrl(projectId) {
    let url = API_HELPERS.endpoints.user.projects.addManyFurnituresToRooms;
    url = url.replace("{projectId}", projectId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static updateRoomParametersUrl(projectId, roomId) {
    let url = API_HELPERS.endpoints.user.projects.updateRoomParameters;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{roomId}", roomId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static updateManyRoomsParametersUrl(projectId) {
    let url = API_HELPERS.endpoints.user.projects.updateManyRoomsParameters;
    url = url.replace("{projectId}", projectId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getAllRoomsUrl(type) {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.projects.settings.rooms +
      `?type=${type}`
    );
  }

  static getAllFurnituresUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.projects.settings.furnitures
    );
  }

  static getFurnituresUrl(inRoomName, notInRoomName) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.projects.settings.furnitures;
    if (inRoomName) url += "?room_name=" + inRoomName;
    else if (notInRoomName) url += "?not_in_room_name=" + notInRoomName;

    return url;
  }

  static getFurnitureImageUrl(furnitureId) {
    let url = API_HELPERS.endpoints.user.projects.settings.furniutrueImage;
    url = url.replace("{furnitureId}", furnitureId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getUploadProfileImageUrl(id = 0) {
    if (!id)
      return (
        API_HELPERS.endpoints.backendUrl +
        API_HELPERS.endpoints.user.uploadProfileImage
      );

    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.uploadProfileImage +
      "/" +
      id
    );
  }

  static removeProfileImageUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.removeProfileImage
    );
  }

  static getRemoveMemberFromProject(id) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.projects.removeMembers;
    url = url.replace("{projectId}", id);
    return url;
  }

  static getStyleQuizPhotosUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.styleQuiz.photos
    );
  }

  static getStyles() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.styleQuiz.styles
    );
  }
  static saveStyle(projectId) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.styleQuiz.saveStyle;
    url = url.replace("{projectId}", projectId);
    return url;
  }

  static getSubmitStyleQuizImagesUrl(id) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.styleQuiz.submitPhotos;
    url = url.replace("{projectId}", id);
    return url;
  }

  // Shopping List
  static getShoppingListUrl(projectId) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.shoppingList.getShoppingList;
    url = url.replace("{projectId}", projectId);
    return url;
  }
  static addProductToShoppingListRoomUrl(projectId, shoppingListId, roomId) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.shoppingList.addProductToShoppingListRoom;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{shoppingListId}", shoppingListId);
    url = url.replace("{roomId}", roomId);
    return url;
  }
  static editShoppingListProductUrl(
    projectId,
    shoppingListId,
    roomId,
    productId
  ) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.shoppingList.editShoppingListProduct;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{shoppingListId}", shoppingListId);
    url = url.replace("{roomId}", roomId);
    url = url.replace("{productId}", productId);
    return url;
  }
  static addRoomToShoppingListUrl(projectId, shoppingListId) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.shoppingList.addRoomToShoppingList;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{shoppingListId}", shoppingListId);
    return url;
  }
  static addImagesToShoppingListRoomProductUrl(
    projectId,
    shoppingListId,
    roomId,
    productId
  ) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.shoppingList
        .addImagesToShoppingListRoomProduct;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{shoppingListId}", shoppingListId);
    url = url.replace("{roomId}", roomId);
    url = url.replace("{productId}", productId);
    return url;
  }
  static removeShoppingListProductImageUrl(
    projectId,
    shoppingListId,
    roomId,
    productId,
    imageId
  ) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.shoppingList.removeShoppingListProductImage;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{shoppingListId}", shoppingListId);
    url = url.replace("{roomId}", roomId);
    url = url.replace("{productId}", productId);
    url = url.replace("{imageId}", imageId);
    return url;
  }

  static removeProductFromShoppingListUrl(
    projectId,
    shoppingListId,
    roomId,
    productId
  ) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.shoppingList.removeProductFromShoppingList;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{shoppingListId}", shoppingListId);
    url = url.replace("{roomId}", roomId);
    url = url.replace("{productId}", productId);
    return url;
  }
  static editOrderOfShoppingListProductUrl(projectId, shoppingListId, roomId) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.shoppingList.editOrderOfShoppingListProduct;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{shoppingListId}", shoppingListId);
    url = url.replace("{roomId}", roomId);
    return url;
  }
  static getProductWebscrapeUrl(link) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.shoppingList.webscrape;
    url += `?urls[1]=${link}`;
    return url;
  }
  /** Shopping list product comments */
  static getProductCommentsUrl(projectId, shoppingListId, roomId, productId) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.shoppingList.getProductComments;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{shoppingListId}", shoppingListId);
    url = url.replace("{roomId}", roomId);
    url = url.replace("{productId}", productId);
    return url;
  }
  static editShoppingListProductAcceptanceUrl(
    projectId,
    shoppingListId,
    roomId,
    productId
  ) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.shoppingList.editShoppingListProductAcceptance;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{shoppingListId}", shoppingListId);
    url = url.replace("{roomId}", roomId);
    url = url.replace("{productId}", productId);
    return url;
  }

  static moveShoppingListProductToAnotherRoomUrl(
    projectId,
    shoppingListId,
    roomId,
    productId
  ) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.shoppingList
        .moveShoppingListProductToAnotherRoom;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{shoppingListId}", shoppingListId);
    url = url.replace("{roomId}", roomId);
    url = url.replace("{productId}", productId);
    return url;
  }
  static deleteShoppingListRoomUrl(projectId, shoppingListId, roomId) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.shoppingList.deleteShoppingListRoom;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{shoppingListId}", shoppingListId);
    url = url.replace("{roomId}", roomId);
    return url;
  }
  static editShoppingListRoomUrl(projectId, shoppingListId, roomId) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.shoppingList.editShoppingListRoom;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{shoppingListId}", shoppingListId);
    url = url.replace("{roomId}", roomId);
    return url;
  }

  static addFilesToShoppingListProductUrl(
    projectId,
    shoppingListId,
    roomId,
    productId
  ) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.shoppingList.addFilesToShoppingListProduct;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{shoppingListId}", shoppingListId);
    url = url.replace("{roomId}", roomId);
    url = url.replace("{productId}", productId);
    return url;
  }
  static removeFileToShoppingListProductUrl(
    projectId,
    shoppingListId,
    roomId,
    productId,
    fileId
  ) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.shoppingList.removeFileToShoppingListProduct;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{shoppingListId}", shoppingListId);
    url = url.replace("{roomId}", roomId);
    url = url.replace("{productId}", productId);
    url = url.replace("{fileId}", fileId);
    return url;
  }

  static editShoppingListUrl(projectId, shoppingListId) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.shoppingList.editShoppingList;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{shoppingListId}", shoppingListId);
    return url;
  }

  static clearShoppingListUrl(projectId, shoppingListId) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.shoppingList.clearShoppingList;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{shoppingListId}", shoppingListId);
    return url;
  }
  static addShoppingListToCartUrl(projectId, shoppingListId) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.shoppingList.addShoppingListToCart;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{shoppingListId}", shoppingListId);
    return url;
  }
  static exportShoppingListUrl(projectId, shoppingListId) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.shoppingList.export;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{shoppingListId}", shoppingListId);
    return url;
  }

  static getShoppingListChangeOrderCategoryUrl(projectId, shoppingListId) {
    let url =
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.shoppingList.changeCategoryOrder;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{shoppingListId}", shoppingListId);
    return url;
  }

  static getAddProjectUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.projects.addProject
    );
  }

  static getAddImageToProjectUrl(projectId) {
    let url = API_HELPERS.endpoints.user.projects.addImageToProject;
    url = url.replace("{projectId}", projectId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getDeleteImageFromProjectUrl(projectId, imageId) {
    let url = API_HELPERS.endpoints.user.projects.deleteImageFromProject;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{imageId}", imageId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getEditProjectUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.projects.editProject
    );
  }

  static getProjectDetailsUrl(id) {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.projects.info +
      "/" +
      id
    );
  }

  static getProjectOrdersUrl(projectId) {
    let url = API_HELPERS.endpoints.user.projects.orders.list;
    url = url.replace("{projectId}", projectId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getArchitectFinances(userId) {
    let url = API_HELPERS.endpoints.user.finances.data;
    url = url.replace("{userId}", userId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getArchitectFinancesMakePayout(walletId) {
    let url = API_HELPERS.endpoints.user.finances.payout;
    url = url.replace("{walletId}", walletId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getArchitectFinancesChangeAccountNumberCode(walletId) {
    let url = API_HELPERS.endpoints.user.finances.accountNumber.getCode;
    url = url.replace("{walletId}", walletId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getArchitectFinancesChangeAccountNumberChange(walletId) {
    let url = API_HELPERS.endpoints.user.finances.accountNumber.change;
    url = url.replace("{walletId}", walletId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getInviteMembersToProjectUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.projects.inviteMembers
    );
  }

  static getResendInviteToProjectUrl(projectId) {
    let url = API_HELPERS.endpoints.user.projects.sendAgainInvitation;
    url = url.replace("{projectId}", projectId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getDeleteProjectUrl(id) {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.projects.deleteProject +
      "/" +
      id
    );
  }

  static getDeleteProjectRoomUrl(projectId, roomId) {
    let url = API_HELPERS.endpoints.user.projects.deleteProjectRoom;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{roomId}", roomId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getUpdateProjectRoomFurnituresUrl(projectId, roomId) {
    let url = API_HELPERS.endpoints.user.projects.updateProjectRoomFurnitures;
    url = url.replace("{projectId}", projectId);
    url = url.replace("{roomId}", roomId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getChangeProductAmountUrl(proposalId, productId) {
    let url = API_HELPERS.endpoints.user.projects.details.changeAmount;
    url = url.replace("{proposalId}", proposalId);
    url = url.replace("{productId}", productId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getDeleteProductProposalUrl(proposalId, productId) {
    let url = API_HELPERS.endpoints.user.projects.details.deleteProduct;
    url = url.replace("{proposalId}", proposalId);
    url = url.replace("{productId}", productId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getAllProductsUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.products.allProducts
    );
  }

  static getAllProductsSortTypesUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.products.sortTypes
    );
  }

  static getExchangeProductInProposalUrl(proposalId) {
    let url = API_HELPERS.endpoints.user.projects.details.exchangeProduct;
    url = url.replace("{proposalId}", proposalId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getAddProductToProposalUrl(proposalId) {
    let url = API_HELPERS.endpoints.user.projects.details.addProductToProposal;
    url = url.replace("{proposalId}", proposalId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  //Comments for product details for specyfic card
  static getAllCommentsUrl(designProposalId) {
    let url = API_HELPERS.endpoints.user.projects.details.comments.getComments;
    url = url.replace("{designProposalId}", designProposalId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getSaveCommentUrl(designProposalId) {
    let url = API_HELPERS.endpoints.user.projects.details.comments.saveComment;
    url = url.replace("{designProposalId}", designProposalId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getSaveSubcommentUrl(designProposalId, subCommentId) {
    let url =
      API_HELPERS.endpoints.user.projects.details.comments.saveSubcomment;
    url = url.replace("{designProposalId}", designProposalId);
    url = url.replace("{subCommentId}", subCommentId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getRemoveCommentUrl(designProposalId, commentId) {
    let url =
      API_HELPERS.endpoints.user.projects.details.comments.removeComment;
    url = url.replace("{designProposalId}", designProposalId);
    url = url.replace("{commentId}", commentId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getRemoveSubcommentUrl(designProposalId, commentId, subCommentId) {
    let url =
      API_HELPERS.endpoints.user.projects.details.comments.removeSubcomment;
    url = url.replace("{designProposalId}", designProposalId);
    url = url.replace("{commentId}", commentId);
    url = url.replace("{subCommentId}", subCommentId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getEditommentUrl(designProposalId, commentId) {
    let url = API_HELPERS.endpoints.user.projects.details.comments.editComment;
    url = url.replace("{designProposalId}", designProposalId);
    url = url.replace("{commentId}", commentId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getEditSubcommentUrl(designProposalId, commentId, subCommentId) {
    let url =
      API_HELPERS.endpoints.user.projects.details.comments.editSubcomment;
    url = url.replace("{designProposalId}", designProposalId);
    url = url.replace("{commentId}", commentId);
    url = url.replace("{subCommentId}", subCommentId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getProductTypesUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.user.products.productTypes
    );
  }

  //Shopping Cart
  static getAllShoppingCart(projectId) {
    let url = API_HELPERS.endpoints.shoppingCart.getAllBasket;
    url = url.replace("{projectId}", projectId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getAddProductToShoppingCartUrl() {
    let url = API_HELPERS.endpoints.shoppingCart.addProductsToBasket;
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getChangeAmountProductInShoppingCartUrl(basketId) {
    let url = API_HELPERS.endpoints.shoppingCart.changeAmountProductInBasket;
    url = url.replace("{basketId}", basketId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getRemoveProductFromShoppingCartUrl(basketId, productId) {
    let url = API_HELPERS.endpoints.shoppingCart.removeProductFromBasket;
    url = url.replace("{basketId}", basketId);
    url = url.replace("{productId}", productId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getPaymentForShoppingCartUrl(basketId) {
    let url = API_HELPERS.endpoints.shoppingCart.paymentForBasket;
    url = url.replace("{basketId}", basketId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  //End Shopping Cart

  static getCurrencyUrl() {
    let url = API_HELPERS.endpoints.currency.currency;
    return API_HELPERS.endpoints.backendUrl + url;
  }

  //ADMIN
  static getAdminStyleQuizStyles() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.admin.styleQuiz.styles
    );
  }

  static updateAdminStyleQuizStyleDescriptionUrl(styleDescId) {
    let url = API_HELPERS.endpoints.admin.styleQuiz.updateStyleDesc;
    url = url.replace("{styleDescId}", styleDescId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static updateAdminStyleQuizStyleImageUrl(styleId) {
    let url = API_HELPERS.endpoints.admin.styleQuiz.updateStyleImage;
    url = url.replace("{styleId}", styleId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static addAdminStyleQuizStyleDescriptionUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.admin.styleQuiz.addStyleDesc
    );
  }

  static getAdminDeleteStyleQuizStyleDescriptionUrl(styleDescId) {
    let url = API_HELPERS.endpoints.admin.styleQuiz.deleteStyleDesc;
    url = url.replace("{styleDescId}", styleDescId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getAdminAllOrdersUrl() {
    return (
      API_HELPERS.endpoints.backendUrl + API_HELPERS.endpoints.admin.orders.list
    );
  }

  static getAdminUpdateOrderUrl(id) {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.admin.orders.update +
      "/" +
      id
    );
  }

  static getAdminAllProductsUrl() {
    return (
      API_HELPERS.endpoints.backendUrl + API_HELPERS.endpoints.admin.allProducts
    );
  }

  static getAdminProductSortTypesUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.admin.productSortTypes
    );
  }

  static getAdminProductTypesUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.admin.productTypes
    );
  }

  static getAdminUsersEwoodsUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.admin.users.ewoods
    );
  }

  static getAdminUpdateUserEwoodsUrl(id) {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.admin.users.ewoodsUpdateUser +
      "/" +
      id
    );
  }

  static getAdminDeleteUserEwoodsUrl(userId) {
    let url = API_HELPERS.endpoints.admin.users.ewoodsDeleteUser;
    url = url.replace("{userId}", userId);
    return API_HELPERS.endpoints.backendUrl + url;
  }
  static getAdminBlockUserEwoodsUrl(userId) {
    let url = API_HELPERS.endpoints.admin.users.ewoodsBlockUser;
    url = url.replace("{userId}", userId);
    return API_HELPERS.endpoints.backendUrl + url;
  }
  static getAdminUnblockUserEwoodsUrl(userId) {
    let url = API_HELPERS.endpoints.admin.users.ewoodsUnblockUser;
    url = url.replace("{userId}", userId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getAdminProducersUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.admin.producers.allProducers
    );
  }
  static getAdminRegions() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.admin.producers.regions
    );
  }

  static getAdminProducerFilesTypesUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.admin.producers.filesTypes
    );
  }

  static getAdminAddProducerUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.admin.producers.addProducer
    );
  }

  static getAdminImportProducerFileUrl() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.admin.producers.files
    );
  }

  static getAdminUpdateProducerUrl(id) {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.admin.producers.updateProducer +
      "/" +
      id
    );
  }

  static getAdminDeleteProducerUrl(id) {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.admin.producers.deleteProducer +
      "/" +
      id
    );
  }

  static getAddNewImagesToProductUrl(productId) {
    let url = API_HELPERS.endpoints.admin.products.images.addNewImages;
    url = url.replace("{productId}", productId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getDeleteImageFromProductUrl(productId, imageId) {
    let url = API_HELPERS.endpoints.admin.products.images.deleteImage;
    url = url.replace("{productId}", productId);
    url = url.replace("{imageId}", imageId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getAllRequestsForPaymentsUrl() {
    let url = API_HELPERS.endpoints.admin.requestsForPayments.all;
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static getChangePaymentStatusUrl(walletId, requestId) {
    let url = API_HELPERS.endpoints.admin.requestsForPayments.changeStatus;
    url = url.replace("{walletId}", walletId);
    url = url.replace("{requestId}", requestId);
    return API_HELPERS.endpoints.backendUrl + url;
  }

  static generalQuizStepsImages() {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.admin.styleQuizSteps.images
    );
  }

  static quizStepsImagesWithId(id) {
    return (
      API_HELPERS.endpoints.backendUrl +
      API_HELPERS.endpoints.admin.styleQuizSteps.images +
      `/${id}`
    );
  }

  //END ADMIN

  static getResponseCodes() {
    return API_CODES;
  }

  static getResponseMessage(code) {
    const { t } = i18n.global;
    if (API_CODES.includes(code)) {
      return t("error_codes." + code);
    } else {
      return t("error_codes.default");
    }
  }

  static axiosCheckGlobalResponseStatus() {
    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        if (error.config.url.includes("auth/")) {
          return Promise.reject(error);
        }
        if (error.response) {
          if (error.response.status === 401) {
            // if you ever get an unauthorized, logout the user
            router.push("/logout");
          }
        }
        return Promise.reject(error);
      }
    );
  }
  static axiosSetRegionHeader(region) {
    axios.defaults.headers.common.Region = region;
  }
}
